import React, { useEffect, useState, useMemo } from "react";
import "../styles/Components/RecordCRUD.scss";
import { useSelector, useDispatch } from "react-redux";
import {CRUDRecordPopup
  } from "../Redux/Slice/rootSlice";
import { useNavigate } from "react-router-dom";
import {
  postRecordsData,
} from "../Redux/Thunk/Actions";
function RecordCRUD(props) {
  // console.log(props.prescriptionid_share,props.patientid_share,"id_share")
  const [fileData, setFileData] = useState();
  const [image, setImage] = useState(null)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
        let files_new = event.target.files[0];
        setFileData(files_new);
        setImage(URL.createObjectURL(event.target.files[0]));
    }
   }
  const [dataSend, setDataSend] = useState({
    description: "",
  });
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const handleCreateRecord = async() => {
    let final_data = {
      "patient_id":props.patientid_share,
      "prescription_id":props.prescriptionid_share
    }
    let formData = new FormData();
    formData.append("file",fileData);
    formData.append("data", JSON.stringify(final_data));
    console.log(formData,"iiiiiiiiiiiiiiiiiiiikkook");
    
    props.loaderchange("true");
    const recordData = postRecordsData(formData);
    const responseRecordData = await dispatch(recordData);
    if (responseRecordData?.payload?.status?.code === 200){
      props.loaderchange("false");
      // console.log(responseRecordData,"testvi")
      props.setclosepopup(false)  
      dispatch(CRUDRecordPopup(false))
      navigate("/viewHistory");
      // console.log(props.currentdatareload,"props.currentdatareload")
      props.datareload(!props.currentdatareload)

    }else{
      // console.log(responseRecordData,"responseRecordData")
      props.loaderchange("false");
    }

    for (var [key, value] of formData.entries()) { 
        // console.log(key, value);
      }

  };
  const dataupdate = (e) => {
    setDataSend({
      ...dataSend,
      [e.target.name]: e.target.value,
    });
  };
  const closeUserPopup=()=>{
    props.setclosepopup(false)
    dispatch(CRUDRecordPopup(false))
  }
  // console.log(dataSend,'dataSend')
//   console.log(fileData, "test");
  return (
    <>
      <div className="record_prescription">
        <div className="modal-dialog_record" role="document">
          <div class="modal-content modelContentChanges">
            <div class="modal-header">
              <h5 class="modal-title">Add Prescription Record</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => closeUserPopup(e)}
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
            <div
              class="modal-body modelBodyChanges"
              style={{ padding: "1rem", width: "920px" }}
            >
              <form onSubmit={handleSubmit}>
                <div class="row">
                  <div class="col-3 title-input">
                    <label for="validationCustom01" style={{fontSize:"18px" }} class="form-label">
                      <span style={{ color: "red"}}>*</span>Upload file
                    </label>
                    {image!=null&&<img alt="preview image" style={{    width: "250px",height: "200px",paddingBottom:"20px"}} src={image}/>}
                    <input
                      type="file"
                      onChange={onImageChange}
                      //   multiple="multiple" //To select multiple files
                    />
                  </div>
                </div>
                <div class="row mt-3">
                  <div className="col-12">
                    <label for="validationCustom01" style={{fontSize:"18px" }} class="form-label">
                      Description
                    </label>
                    <textarea
                      class="form-control inputStyleChange"
                      value={dataSend.description}
                      name="description"
                      style={{    height: "100px"}}
                      onChange={(e) => {
                        dataupdate(e);
                      }}
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary  create mt-3"
                  onClick={(e) => handleCreateRecord(e)}
                >
                  Create Record
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RecordCRUD;
